import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  bootstrapApplication,
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration,
} from '@angular/platform-browser';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { AppModule } from '@app/app.module';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (typeof window !== 'undefined') {
    window.console.log = () => {};
    window.console.warn = () => {};
  }
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    importProvidersFrom(AppModule),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideZoneChangeDetection(),
  ],
}).catch((err) => console.error(err));
